// extracted by mini-css-extract-plugin
export default {"iframe_modal":"style_iframe_modal__oVqMe","iframe":"style_iframe__QJrhg"};